import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { JurisdictionSettings } from "../models/jurisdiction-settings.model";

@Injectable({
    providedIn: 'root',
})
export class JurisdictionSettingsService {
    private defaultSettings: JurisdictionSettings;
    private jurisdictionSettings: JurisdictionSettings[];

    constructor(private http: HttpClient) { }

    public async loadSettings(): Promise<boolean> {
        if (!this.jurisdictionSettings) {
            this.jurisdictionSettings = await this.http.get<any>(`assets/jurisdictionSettings/jurisdictionsettings.json`, { headers: new HttpHeaders({ 'Cache-Control': 'no-cache ,no-store' })})
                .pipe(map((res: any[]) => {
                    this.defaultSettings = res.find(val => !val.jurisdiction);
                    return res.filter(val => val.jurisdiction)
                        .map(val => <JurisdictionSettings>(Object.assign(Object.assign({}, this.defaultSettings), val)));
                }))
                .toPromise();
        }
        
        return true;
    }

    public getCurrentSettings(jurisdictionCode: string): JurisdictionSettings {
        return this.jurisdictionSettings.find(x => x.jurisdiction.toUpperCase() === jurisdictionCode?.toUpperCase()) ?? this.defaultSettings;
    }
}